import React, { useState, useRef, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import PropTypes from "prop-types";
import { Row, Col, Form, Space, Input, Spin } from "antd";
import {
  MinusSquareFilled,
  PlusSquareFilled,
  SaveOutlined,
} from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { getRequest, patchRequest } from "../../axios";
import {
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import ButtonField from "../../common/htmlComponents/ButtonField";

const PaymentPersonReleasedField = ({
  VendorId,
  paymentReleasedId,
  setPaymentReleasedId,
  gstVendorId,
  gstValue,
}) => {
  const formRef = useRef();
  const { t } = useTranslation();

  const initialState = {
    payment_released: [
      {
        person_name: null,
        email: null,
        designation: null,
        contact_number: null,
        department: null,
      },
    ],
  };
  const [state, setState] = useState(initialState);
  const [btnLoading, setBtnLoading] = useState(false);

  const [apiLoading, setapiloading] = useState(false);

  const handleCloneInputChange = (field, e, index) => {
    let newPersonArr = state.payment_released;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, payment_released: newPersonArr });
  };
  const removePerson = async (lastIndex) => {
    let filterPersonArr = state.payment_released.filter(
      (item, index) => index !== lastIndex
    );
    setState({ ...state, payment_released: filterPersonArr });
    setWeightSizeFieldValue(filterPersonArr);
  };

  const setWeightSizeFieldValue = (data) => {
    let stateArr = [];
    let fieldObject = {};
    console.log(data);
    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["person_name" + objectKey] = objectValue.person_name;
      fieldObject["email" + objectKey] = objectValue.email;
      fieldObject["department" + objectKey] = objectValue.department;
      fieldObject["designation" + objectKey] = objectValue.designation;
      fieldObject["contact_number" + objectKey] = String(
        objectValue.contact_number || "+91"
      );
      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };
  const addPerson = () => {
    let newPersonArr = [
      ...state.payment_released,
      {
        person_name: null,
        email: null,
        designation: null,
        contact_number: null,
        department: null,
      },
    ];
    setState({ ...state, payment_released: newPersonArr });
    setWeightSizeFieldValue(newPersonArr);
  };
  const handleClonePhoneInputChange = (field, phone, index) => {
    let newPersonArr = state.payment_released;
    newPersonArr[index][field] = phone ? phone : null;
    setState({ ...state, payment_released: newPersonArr });
  };

  useEffect(() => {
    const getVendorOnboarding = async () => {
      setapiloading(true);
      try {
        const vendor = gstVendorId ? gstVendorId : VendorId;
        const apiResponse = await getRequest(
          `vendor-payment-released/?vendor=${VendorId}`
        );
        if (apiResponse.data.success) {
          if (apiResponse.data.success) {
            setState({
              payment_released: apiResponse.data.data.map((keyPerson) => {
                const { vendor, vendor_name, company_name, ...rest } =
                  keyPerson;
                return rest;
              }),
            });

            const modifiedKeypersons = apiResponse.data.data.map(
              (keypersonDetail) => {
                const { id, vendor, vendor_name, ...rest } = keypersonDetail;
                return rest;
              }
            );
            setWeightSizeFieldValue(modifiedKeypersons);

            if (VendorId !== null) {
              // setIsGstNoReadOnly(true);
            }
          }
        } else {
          // ErrorNotificationMsg(t("err_getSubscription"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };

    const getGstVendorOnboarding = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest(
          `vendor-payment-released/payment-released-by-gst/?gst_no=${gstValue}`
        );
        if (apiResponse.data.success) {
          console.log(apiResponse);
          setPaymentReleasedId(apiResponse?.data?.data[0]?.id);
          setState({
            payment_released: apiResponse.data.data.map((keyPerson) => {
              const { vendor, vendor_name, company_name, ...rest } = keyPerson;
              return rest;
            }),
          });

          const modifiedKeypersons = apiResponse.data.data.map(
            (keypersonDetail) => {
              const { vendor, vendor_name, ...rest } = keypersonDetail;
              return rest;
            }
          );
          setWeightSizeFieldValue(modifiedKeypersons);

          if (VendorId !== null) {
            //setIsGstNoReadOnly(true);
          }
        } else if (apiResponse.data.success === false) {
          console.log(apiResponse);
          setState({
            payment_released: apiResponse.data.data.map((keyPerson) => {
              const { vendor, vendor_name, company_name, ...rest } = keyPerson;
              return rest;
            }),
          });

          const modifiedKeypersons = apiResponse.data.data.map(
            (keypersonDetail) => {
              const { vendor, vendor_name, ...rest } = keypersonDetail;
              return rest;
            }
          );
          setWeightSizeFieldValue(modifiedKeypersons);
          setPaymentReleasedId(null);
          if (VendorId !== null) {
            //setIsGstNoReadOnly(true);
          }
        }
        else {
          // ErrorNotificationMsg(t("err_getSubscription"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    if (VendorId !== null && gstVendorId === null) {
      getVendorOnboarding();
    }
    if (gstVendorId !== null) {
      getGstVendorOnboarding();
    }
  }, [VendorId, gstVendorId, t, gstValue]);

  const handleSubmit = async () => {
    const payload = {
      payment_released:
        state.payment_released &&
        state.payment_released.every(
          (person) =>
            person.person_name === null &&
            person.email === null &&
            person.designation === null &&
            person.contact_number === null &&
            person.department === null
        )
          ? 
            []
          : state.payment_released,
    };
    try {
      setBtnLoading(true);

      let response;
      if (paymentReleasedId === null) {
        const url =
          VendorId !== null
            ? `vendor-payment-released/${VendorId}/add-payment-released/`
            : `vendor-payment-released/${gstVendorId}/add-payment-released/`;
        response = await patchRequest(url, payload);
      } else {
        const url =
          VendorId !== null
            ? `vendor-payment-released/${VendorId}/`
            : `vendor-payment-released/${gstVendorId}/`;

        response = await patchRequest(url, payload);
      }
      if (response.data.success) {
        SuccessNotificationMsg(
          paymentReleasedId === null
            ? t("payment_terms_added_successfully")
            : t("payment_terms_updated_successfully")
        );

        setState({
          payment_released: response.data.data.payment_released.map(
            (keyPerson) => {
              const { vendor, vendor_name, company_name, ...rest } = keyPerson;
              return rest;
            }
          ),
        });

        const modifiedKeypersons = response.data.data.payment_released.map(
          (keypersonDetail) => {
            const { vendor, vendor_name, ...rest } = keypersonDetail;
            return rest;
          }
        );
        setWeightSizeFieldValue(modifiedKeypersons);
        setPaymentReleasedId(response.data.data.payment_released[0].id);
        setBtnLoading(false);
      }
    } catch (error) {
      VendorId === null
        ? t("error_in_adding_keyperson")
        : t("error_in_updating_keyperson");
      setBtnLoading(false);
    }
  };

  return (
    <>
      <Spin spinning={apiLoading}>
        <Form autoComplete="off" ref={formRef}>
          {state.payment_released &&
            state.payment_released.map((x, index) => {
              return (
                <>
                  <Row key={index} className="customcol" gutter={[16]}>
                                <Col xs={22} sm={22} md={22} xl={22} xxl={22}>
                                <Row  gutter={[16]}>
                    <Col xs={24} sm={12} md={8} xl={4} xxl={4}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        name={`person_name` + index}
                        label={t("pl_personName")}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("pl_gst")}</Trans>,
                          },
                          {
                            pattern: /^[a-zA-Z_ ]+$/,
                            message: "Please Enter Valid Name",
                          },
                          {
                            min: 2,
                            message: <Trans>{t("minlength_msg")}</Trans>,
                          },
                          {
                            max: 15,
                            message: <Trans>{t("maxlength_personName")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          className="cust-input"
                          placeholder={t("pl_personName")}
                          onChange={(value) =>
                            handleCloneInputChange("person_name", value, index)
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} xl={4} xxl={4}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        name={`designation` + index}
                        label={t("lbb_designation")}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("val_designation")}</Trans>,
                          },
                          {
                            min: 3,
                            message: <Trans>{t("minlength_msg")}</Trans>,
                          },
                          {
                            max: 30,
                            message: (
                              <Trans>{t("maxlength_designation")}</Trans>
                            ),
                          },
                          {
                            pattern: /^[a-zA-Z_ ]+$/,
                            message: "Please Enter Valid Designation",
                          },
                        ]}
                      >
                        <Input
                          className="cust-input"
                          placeholder={t("pl_designation")}
                          onChange={(value) =>
                            handleCloneInputChange("designation", value, index)
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} xl={4} xxl={4}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        name={`department` + index}
                        label={t("pl_department")}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("Please Enter Department")}</Trans>,
                          },
                          {
                            min: 3,
                            message: <Trans>{t("minlength_msg")}</Trans>,
                          },
                          {
                            max: 30,
                            message: (
                              <Trans>{t("maxlength_designation")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Input
                          className="cust-input"
                          placeholder={t("Enter Department")}
                          onChange={(value) =>
                            handleCloneInputChange("department", value, index)
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} xl={6} xxl={6}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        name={`email` + index}
                        label={t("lbb_email")}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("val_email")}</Trans>,
                          },
                          {
                            type: "email",
                            message: <Trans>{t("val_email")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          className="cust-input"
                          placeholder={t("pl_email")}
                          onChange={(value) =>
                            handleCloneInputChange("email", value, index)
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} xl={6} xxl={6}>
                      <div className="verifywrap">
                        <Form.Item
                          name={`contact_number` + index}
                          label={t("pl_ContactNo")}
                          pattern={"/^d{12}$/"}
                          rules={[
                            
                            {
                              message: <Trans>{t("val_phone")}</Trans>,
                            },
                            {
                              pattern: /^\d{12}$/,
                              message: <Trans>{t("val_phone")}</Trans>,
                            },
                          ]}
                        >
                          <PhoneInput
                            className="PhoneSection"
                            country={"in"}
                            onChange={(phone) =>
                              handleClonePhoneInputChange(
                                "contact_number",
                                phone,
                                index
                              )
                            }
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    
                  </Row>
                                </Col>
                                <Col xs={24} sm={2} md={2} xl={2} xxl={2}>
                                <div className="addwrp">
                        <Space>
                          {index !== 0 ? (
                            <MinusSquareFilled
                              className="add"
                              onClick={() => removePerson(index)}
                            />
                          ) : (
                            ""
                          )}

                          <PlusSquareFilled
                            className="add"
                            onClick={(e) => addPerson(e)}
                          />
                        </Space>
                      </div>
                                </Col>
                                </Row>
                 
                </>
              );
            })}
          {VendorId || gstVendorId ? (
            <div className="subbuttonsrow">
         
              <ButtonField
                type="primary"
                icon={<SaveOutlined />}
                onClick={handleSubmit}
                label={t("save")}
                loading={btnLoading}
              />
            </div>
          ) : (
            ""
          )}
        </Form>
      </Spin>
    </>
  );
};
PaymentPersonReleasedField.propTypes = {
  VendorId: PropTypes.number,
  paymentReleasedId: PropTypes.number,
  setPaymentReleasedId: PropTypes.func,
  gstVendorId: PropTypes.number,
  gstValue: PropTypes.number,
};
export default PaymentPersonReleasedField;
